RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const MAX_AD_OBJECT_NAME_LENGTH = 40;

    views.ObservationsView = Marionette.LayoutView.extend({
        template: '#adObservation',

        ui: {
            information: '.fa-info-circle'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        serializeData: function () {
            const me = this;

            const showMixedCampaignWarning = Boolean(me.getOption('showMixedCampaignWarning'));
            const observations = me.getOption('observations') || [];
            return {
                observations: observations,
                MAX_AD_OBJECT_NAME_LENGTH: MAX_AD_OBJECT_NAME_LENGTH,
                showMixedCampaignWarning: showMixedCampaignWarning
            };
        },

        templateHelpers: function () {
            return _.extend({
                s: s
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        onRender: function () {
            const me = this;
            me.ui.information.popover();
        }
    });

}, window.s);
